<script lang="ts" setup>
  import { BaseButton } from '@bt/design-system'
  import type Link from '@/types/Storyblok/Generic/Link'

  const { locale } = useI18n()
  const props = defineProps<{ blok: any }>()

  const config = useRuntimeConfig()
  const hasValidUrl = computed(() => props.blok.href?.story?.full_slug ?? props.blok.href)

  const getPath = (href: Link) => {
    if (!hasValidUrl.value) {
      return
    }

    if (href.story) {
      const external = String(href?.story?.full_slug)?.includes('company-airbaltic-com')
      let path = formatSbPath(href.story.full_slug, locale.value)
      if (external) {
        path = config.public.companyUrl + '/' + locale.value + '/' + path
      }

      return formatSbPath(path, locale.value)
    }

    if (href.url) {
      return href.url
    }
  }
</script>

<template>
  <NuxtLink
    v-if="hasValidUrl"
    :to="getPath(blok.href)"
    :target="blok.target"
  >
    <BaseButton
      :color="blok.color"
      :icon-color="blok.iconColor"
      :is-block="blok.isBlock"
      :prepend-icon="blok.icon"
      :title="blok.title"
      :type="blok.type"
      block-type="full-on-mobile"
      density="default"
    />
  </NuxtLink>
</template>
